module.exports = __webpack_public_path__ + "static/principles-wheel-b88ae7f903044e201cc69eabdd80805a.svg";